import router from './router'
import store from './store'
import { getToken } from '@/utils/auth'
import { isPathMatch } from '@/utils/validate'
import { Message } from 'element-ui'


const whiteList = ['/login', '/register', '/forgotPwd']

const isWhiteList = (path) => {
  return whiteList.some(pattern => isPathMatch(pattern, path))
}
let errCount = 0;
const maxErrCount = 10;

router.beforeEach((to, from, next) => {
  // 🔥 开发环境直接放行
  // if (process.env.NODE_ENV === 'development') {
  //   next()
  //   return
  // }

  if (getToken()) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
    } else if (isWhiteList(to.path)) {
      next()
    } else {
      if (!store.getters.userInfo) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(() => {
          store.dispatch('GenerateRoutes').then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            // companyInfoState为0时跳转到/user页面
            const userInfo = store.getters.userInfo;
            if (userInfo && userInfo.companyInfoState === 0 && to.path !== '/user') {
              Message.warning("请完善账户信息");
              next({ path: '/user', replace: true });
              return;
            }
            next({ ...to, replace: true });
          }).catch(() => {})
        }).catch(err => {
            errCount ++;
            if(errCount > maxErrCount) {
              store.dispatch('ExpireSession');
              location.href = '/login';
            }else{
              next({ path: '/' });
            }
        })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (isWhiteList(to.path)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login`) // 否则全部重定向到登录页
    }
  }
})
